import React from 'react';
import css from './Mustache.module.scss';

export const Mustache: React.FC = () => <div className={css.mustache} />;
